import { render, staticRenderFns } from "./initiate.vue?vue&type=template&id=7ab90e1a&scoped=true&"
import script from "./initiate.vue?vue&type=script&lang=js&"
export * from "./initiate.vue?vue&type=script&lang=js&"
import style0 from "./initiate.vue?vue&type=style&index=0&id=7ab90e1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab90e1a",
  null
  
)

export default component.exports